/* eslint-disable indent */
import styled from 'styled-components';
import colors from '../../assets/colors';

export const Content = styled.div`
  position: absolute;
  max-width: 1170px;
  flex: 1;
  margin-bottom: 50px;

  .stats {
    display: flex;
    flex: 1;
    align-items: center;
    
    .container {
      margin-right: 30px;

      h3 {
        font-size: 0.91rem;
        font-weight: 700;
        color: #999;
        text-transform: uppercase;
      }

      span {
        font-size: 0.9rem;
        font-weight: 700;

        .fa-star { margin-right: 5px; margin-bottom: -1.5px; }
      }

      .star { color: #FACA07; }

      :last-child { margin-right: 0; }
    }
  }

  .controls {
    display: flex;
    margin-bottom: 30px;
    
    .list-controls {
      display: flex;
      
      .items-found {
        padding: 10px 15px;

        span {
          font-size: 0.9rem;
          color: #CCC;
        }
      }

      .filters {
        width: 138px;
        height: 39px;
        display: flex;
        align-items: center;
        flex-direction: space-between;
        padding: 0 10px;
        background-color: ${colors.white};
        box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
        border-radius: 8px;
        border: ${(props) => {
          // if (props.error) return `1px solid ${colors.red}`;
          if (props.filter) return `1px solid ${colors.primary}`;
          return `1px solid ${colors.white}`;
        }};
        cursor: context-menu;

        .text {
          flex: 1;
          padding-right: 20px;
          font-size: 0.85rem;
          -webkit-touch-callout: none; 
          -webkit-user-select: none; 
          -khtml-user-select: none; 
          -moz-user-select: none; 
          -ms-user-select: none; 
          user-select: none; 
        }

        .separator {
          border-left: 1px solid #CCC;
          height: 23px;
        }

        .fa-angle-down {
          padding-left: 9px;
          margin-top: 2px;
          font-size: 1.05rem;
          color: #CCC;
        }
      }
    }
  }

  @media screen and (max-width: 620px) {
    .controls {
      flex-direction: column;

      .stats {
        margin-bottom: 30px;

        .container:first-child { margin-right: 15px; }
      }

      .list-controls {
        justify-content: space-between;
        flex-wrap: wrap;
        
        .items-found { padding: 10px 0 !important; }
      }
    }
  }

  @media screen and (max-width: 1089px) {
    right: 20px;
    left: 20px;
  }

  @media (min-width: 1090px) and (max-width: 1248px) {
    right: 30px;
    left: 30px;
  }

  @media (min-width: 1249px) {
    width: 100%;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 11px 0;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;
  cursor: pointer;

  :hover { opacity: .9 }
`;
